import { Box } from '@mui/material';
import React from 'react';
import { SelectableCard } from './SelectableCard';
import { getCardColors } from './cardColors';
import { CardActions, CardIconCheckbox } from './components';
/**
 * A selectable card component with an icon positioned absolutely.
 *
 * @param {SelectableIconCardProps} props - Props for the SelectableIconCard component.
 * @param {React.ReactNode} props.children - Content to render inside the card.
 * @param {string} props.color - Color key used to determine the background color.
 * @param {...any} props.rest - Additional props passed to child components.
 * @returns {JSX.Element} The rendered selectable icon card.
 */
export const SelectableIconCard = (props) => {
    return (React.createElement(Box, { sx: { position: 'relative' } },
        React.createElement(SelectableCard, Object.assign({}, props, { sx: { display: 'grid', gridTemplateColumns: 'auto 1fr auto' } }),
            React.createElement(Box, { sx: { width: 80, minHeight: 80, backgroundColor: getCardColors()[props.color] } }),
            React.createElement(Box, { sx: { alignSelf: 'center', overflow: 'hidden' } }, props.children),
            React.createElement(CardActions, Object.assign({}, props))),
        React.createElement(Box, { sx: { position: 'absolute', top: 'calc(50% - 40px)', left: 1 } },
            React.createElement(CardIconCheckbox, Object.assign({}, props)))));
};
